import * as React from "react";
import { memo, useEffect } from "react";
import "./filtersViewStyles.css";
import { SelectFilterView } from "./SelectFilterView";
import { useTranslation } from "react-i18next";
import { focusManager } from "../../../utils/Focus";
import { useFocusable } from "../../../utils/Helpers";
export var MovieFiltersView = memo(function (_a) {
    var genres = _a.genres, languages = _a.languages, filters = _a.filters, handleChosenGenre = _a.handleChosenGenre, handleChosenDubb = _a.handleChosenDubb, handleClearFilters = _a.handleClearFilters, verticalContainer = _a.verticalContainer;
    var t = useTranslation().t;
    useEffect(function () {
        focusManager.registerGroup({
            name: "filters",
            position: 2,
            itemHeight: 120,
            verticalContainer: verticalContainer,
        });
    }, [verticalContainer]);
    var clearFilterRef = useFocusable({
        group: "filters",
        index: 2,
        onKeyDown: handleClearFilters,
    });
    return (React.createElement("div", { id: "filters", className: "filters-container" },
        React.createElement(SelectFilterView, { focusRaw: ["filters", 0], options: genres, filter: "genres", onSelect: handleChosenGenre, selected: filters.genres, filterName: t("filters.genres") }),
        React.createElement(SelectFilterView, { focusRaw: ["filters", 1], options: languages, filter: "dubbing", onSelect: handleChosenDubb, selected: filters.dubbing, filterName: t("filters.dubbing") }),
        React.createElement("button", { ref: clearFilterRef, tabIndex: 0, className: "clear-filters-btn" }, t("filters.clear"))));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/filter/MovieFiltersView.tsx
// module id = 160
// module chunks = 1